//@ts-ignore
const CONTACT_FORM_ENDPOINT: string = process.env.REACT_APP_CONTACT_FORM_API_ENDPOINT;

type ContactUsFromProps = {
  name: string;
  lastName: string;
  fieldOfInterest: string;
  companyName: string;
  country: string;
  email: string;
  message: string;
  phone: string;
  token: string;
};

export const submitContactForm = async (formData: ContactUsFromProps) => {
  const formatedFormData = {
    Name: formData.name,
    Last_Name: formData.lastName,
    Field_of_interest: formData.fieldOfInterest,
    Company_Name: formData.companyName,
    Country: formData.country,
    Email: formData.email,
    Phone: formData.phone,
    Message: formData.message,
    Token: formData.token,
  };
  return await fetch(`${CONTACT_FORM_ENDPOINT}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body: JSON.stringify(formatedFormData),
  });
};
